// extracted by mini-css-extract-plugin
module.exports = {"Tag":"ProjectDetails_Tag__1H3jt","ProjectDetails":"ProjectDetails_ProjectDetails__1aMFn","anim":"ProjectDetails_anim__55Vig"};